export const DRAW_ITEM_EVENT_LIST_REQUEST = 'DRAW_ITEM_EVENT_LIST_REQUEST';

export const DRAW_ITEM_EVENT_CREATE_REQUEST = 'DRAW_ITEM_EVENT_CREATE_REQUEST';

export const DRAW_ITEM_EVENT_INFO_REQUEST = 'DRAW_ITEM_EVENT_INFO_REQUEST';

export const DRAW_ITEM_EVENT_LOG_INFO_REQUEST = 'DRAW_ITEM_EVENT_LOG_INFO_REQUEST';

export const DRAW_ITEM_EVENT_REMOVE_REQUEST = 'DRAW_ITEM_EVENT_REMOVE_REQUEST';

export const DRAW_ITEM_EVENT_UPDATE_REQUEST = 'DRAW_ITEM_EVENT_UPDATE_REQUEST';
